/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Reduces API quota consumption for update events by filtering irrelevant change events at the source, so only updates that affect watched fields are delivered. Requires `updateEvent.requiredWatchFields` to be non-empty; it cannot be used with `updateEvent.watchFieldsAuto: all`. Currently supported for Salesforce.
 * @export
 * @interface QuotaOptimizationConfig
 */
export interface QuotaOptimizationConfig {
    /**
     * Whether quota optimization is enabled for this object.
     * @type {boolean}
     * @memberof QuotaOptimizationConfig
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the QuotaOptimizationConfig interface.
 */
export function instanceOfQuotaOptimizationConfig(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "enabled" in value;

    return isInstance;
}

export function QuotaOptimizationConfigFromJSON(json: any): QuotaOptimizationConfig {
    return QuotaOptimizationConfigFromJSONTyped(json, false);
}

export function QuotaOptimizationConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuotaOptimizationConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
    };
}

export function QuotaOptimizationConfigToJSON(value?: QuotaOptimizationConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
    };
}

